<template>
  <section id="user-activities">
    <div class="ua-top-container">
      <div class="ua-header-container">
        <div class="page-label">
          Customer Activities
        </div>
        <SelectedPartner />
      </div>
    </div>
    <div class="ua-body-container">
      <div class="ua-content-container">
        <UserActivitiesTable />
      </div>
    </div>
  </section>
</template>

<script>
import UserActivitiesTable from '@shared/components/userActivities/UserActivitiesTable.vue';
import adminMixin from '@shared/mixins/adminMixin';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';
import userActivitiesMixin from '@shared/mixins/userActivitiesMixin';

export default {
  name: 'UserActivities',
  metaInfo: {
    title: 'SmartAC.com | User Activities',
  },
  components: {
    SelectedPartner,
    UserActivitiesTable,
  },
  mixins: [adminMixin, userActivitiesMixin],
  watch: {
    selectedCorpId() {
      this.initialLoad();
    },
  },
  mounted() {
    if (this.isManufactureAdmin) {
      this.$router.replace('/quality');
    } else {
      this.initialLoad();
    }
  },
  methods: {
    async initialLoad() {
      this.$store.dispatch('getUserActivities');
      this.$store.dispatch('getUserActivitiesPartners');
    },
  },
};
</script>

<style lang="scss" scoped>

section#user-activities {
  @include section-container;

  .ua-top-container {
    @include section-top-container;

    .ua-header-container {
      @include section-header-container;
    }
  }

  .ua-body-container {
    @include section-body-container;

    .ua-content-container {
      @include section-content-container;

      .ua-row-container {
        display: flex;
        align-items: center;
        margin-bottom: 26px;
      }
    }
  }
}
</style>
